import React from 'react';
import {Route} from 'react-router';
import Header from './header';
import Footer from './footer';
import Sidebar from './sidebar';
import PageHeader from './pageheader';

export default ({component: Component, ...rest}) => (
  <Route
    {...rest}
    render={matchProps => (
      <div className="kt-grid kt-grid--hor kt-grid--root">
        <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
          <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper">
            <Header />
            <div className="kt-container kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-grid--stretch">
              <Sidebar />
              <div className="kt-holder kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
                <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor">
                  <PageHeader title={rest.title} {...rest} {...matchProps} />
                  <div className="kt-content kt-grid__item kt-grid__item--fluid">
                    <div className="row">
                      <div className="col-md-12">
                        <div
                          className={`kt-portlet kt-page-container ${
                            rest.className
                          }`}
                        >
                          {rest.subtitle && (
                            <div className="kt-portlet__head">
                              <div className="kt-portlet__head-label">
                                <h3 className="kt-portlet__head-title">
                                  {rest.subtitle}
                                </h3>
                              </div>
                            </div>
                          )}
                          <div className="kt-portlet__body">
                            <Component {...matchProps} />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </div>
        </div>
      </div>
    )}
  />
);
